import { ImportedDataType } from 'lib/imported-data/ImportedData.types';
import { SPARKLE_PAGE_IDS } from './static';

/** Utility function that takes an HTML snippet from Sparkle and adds the content to a given HTMLElement on the DOM.
 * Importantly, it also extracts and appends any script tags to the body of the document.
 */
const applyHtmlSnippet = async (htmlSnippet: string, toElement: HTMLElement) => {
  const doc = new DOMParser().parseFromString(htmlSnippet, 'text/html');

  // Extract and remove scripts
  const scripts = Array.from(doc.getElementsByTagName('script'));
  scripts.forEach((script) => script.remove());

  // Update content
  toElement.innerHTML = doc.body.innerHTML;

  // Append scripts
  scripts.forEach((script) => {
    const newScript = document.createElement('script');
    script.getAttributeNames().forEach((attr) => {
      newScript.setAttribute(attr, script.getAttribute(attr) || String());
    });
    newScript.textContent = script.textContent;
    document.body.appendChild(newScript);
  });
};

const getSlug = (url: string): string => {
  const slug = url.split('/').pop() || '';
  return slug.split(/[?#]/)[0];
};

const getCanonicalUrl = (linkTag: string): string => {
  const pattern = /url=(['"])([^'"]+)\1/;
  const match = linkTag.match(pattern);
  return match ? match[2] : '';
};

const isEmptyOrWhiteSpace = (str: string): boolean => !str || /^\s*$/.test(str);

const sparklePageTypeMap: Record<string, ImportedDataType> = {
  [SPARKLE_PAGE_IDS.Provider.toLowerCase()]: ImportedDataType.SparkleProvider,
  [SPARKLE_PAGE_IDS.Location.toLowerCase()]: ImportedDataType.SparkleLocation,
  [SPARKLE_PAGE_IDS.Event.toLowerCase()]: ImportedDataType.SparkleEvent,
};

const getSparklePageType = (templateId?: string | null): ImportedDataType | undefined => {
  return templateId ? sparklePageTypeMap[templateId.toLowerCase()] : undefined;
};

export const sparkleUtils = {
  applyHtmlSnippet,
  getSlug,
  getCanonicalUrl,
  isEmptyOrWhiteSpace,
  getSparklePageType,
};
